import { tv } from "tailwind-variants";

export const text = tv({
  base: "font-primary",
  variants: {
    size: {
      "display-large": "text-6xl leading-[var(--lh-heading)]",
      "display-medium": "text-5xl leading-[var(--lh-heading)]",
      "display-small": "text-4xl leading-[var(--lh-heading)]",
      "headline-large": "text-3xl leading-[var(--lh-heading)]",
      "headline-medium": "text-2xl leading-[var(--lh-heading)]",
      "headline-small": "text-xl leading-[var(--lh-heading)]",
      "title-large": "text-lg leading-[var(--lh-normal)]",
      "title-medium": "text-base leading-[var(--lh-normal)]",
      body: "text-base leading-[var(--lh-normal)]",
      "title-small": "text-sm leading-[var(--lh-small)]",
      "title-xsmall": "text-xs leading-[var(--lh-small)]",
    },
    weight: {
      bold: "font-bold",
      semibold: "font-semibold",
      regular: "font-normal",
      light: "font-light",
    },
    family: {
      primary: "font-dm-sans",
      secondary: "font-lato",
    },
  },
  defaultVariants: { size: "body", weight: "regular", family: "primary" },
});
